import { CHAT_BASE_URL } from "@/config/urls.config";
import { useEffect, useState } from "react";
import io, { Socket } from "socket.io-client";

export const useSocket = (
  userId: string | number | null | undefined,
  supplierUuid: string | null | undefined,
  isWppView = true,
  suffix: string | null = null
): Socket | null => {
  const [socket, setSocket] = useState<Socket | null>(null);

  useEffect(() => {
    if (!supplierUuid) return;

    const socketInstance = io(CHAT_BASE_URL, {
      query: {
        supplierUuid: supplierUuid,
        isWppView,
        userId: userId,
        suffix: suffix,
      },
      transports: ["websocket"],
      reconnectionAttempts: 2,
    });

    setSocket(socketInstance);

    socketInstance.on("connect", () => {
      socketInstance.emit(`pending-chats-back-${supplierUuid}`, {
        connect: true,
      });
    });

    socketInstance.on("disconnect", () => {
      console.log("Disconnected from server");
    });

    socketInstance.on("reconnect", (attemptNumber: number) => {
      console.log(`Reconnected after ${attemptNumber} attempts`);
    });

    return () => {
      socketInstance.disconnect();
    };
  }, [supplierUuid, userId]);

  return socket;
};
